import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import ViewResults from "../../measurement/geo-lift/components/ViewResults";

interface StepIncrementalityResultsProps {
  jobConfigId: string;
  isSales: boolean;
  onPrevious: () => void;
}

// This step is the real Synthetic Control "Incrementality Results" page,
// reused verbatim - same real per-market batch processing (useGeoLiftForm +
// useGeoLiftDataProcessor hooks), same KPI tiles/chart, same per-market table
// with View Details -> MarketDetailsModal - per explicit instruction, not a
// simplified aggregate-only approximation. It is fully self-sufficient (it
// fetches /api/geo-lift/output/{jobConfigId} and the post-test CSV itself),
// so resultData/setPostTestData are inert here - the same way GeoLiftStudy.tsx
// only truly needs them for its own results-caching, which this wizard
// doesn't do. ViewResults.tsx itself is NOT modified; only wrapped with the
// wizard's own Previous/Finish footer.
const StepIncrementalityResults: React.FC<StepIncrementalityResultsProps> = ({
  jobConfigId,
  isSales,
  onPrevious,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col">
      <ViewResults
        jobConfigId={jobConfigId}
        resultData={null}
        setPostTestData={() => {}}
        mode={null}
        isSales={isSales}
      />

      <div className="flex justify-between mt-6">
        <Button size="large" onClick={onPrevious}>
          Previous
        </Button>
        <Button type="primary" size="large" onClick={() => navigate("/causal-loop/list")}>
          Finish
        </Button>
      </div>
    </div>
  );
};

export default StepIncrementalityResults;
